import React, { useState } from 'react';
import * as S from './styled';
import { useDeviceType } from '../../hooks';
import Icon from '../Icon';
import {
  headerShareText,
  headerShareGuideName,
  headerShareGuideSettings,
} from '../../utils/constants';
import {
  URL_TO_SHARE,
  URL_WHATSAPP_SHARE,
  URL_FACEBOOK_SHARE,
  URL_TWITTER_SHARE,
} from '../../config/endpoints';

const Share = () => {
  const [toggle, setToggle] = useState(false);
  const { mobile } = useDeviceType();

  const openSharePage = url => () => {
    window.open(url, headerShareGuideName, headerShareGuideSettings);
  };

  const handleToggle = () => setToggle(!toggle);

  return mobile ? (
    <Icon
      icon="compartilhar"
      onClick={() => {
        if (navigator.share) {
          navigator.share({ url: URL_TO_SHARE(), text: headerShareText });
        }
      }}
    />
  ) : (
    <S.ShareContainer>
      <S.ShareIcon icon="compartilhar" header onClick={handleToggle} />
      <S.StyledDropdown open={toggle} onClose={handleToggle}>
        <S.StyledArrow className="arrow" direction="up" size="12" />
        <S.DropdownList>
          <S.DropdownItem>Compartilhe com:</S.DropdownItem>
          <S.DropdownItem
            onClick={openSharePage(URL_FACEBOOK_SHARE(headerShareText))}
          >
            <S.ShareIcon icon="facebook" />
            Facebook
          </S.DropdownItem>
          <S.DropdownItem
            onClick={openSharePage(URL_TWITTER_SHARE(headerShareText))}
          >
            <S.ShareIcon icon="twitter" />
            Twitter
          </S.DropdownItem>
          <S.DropdownItem
            onClick={openSharePage(URL_WHATSAPP_SHARE(headerShareText))}
          >
            <S.ShareIcon icon="telefonar" />
            Whatsapp
          </S.DropdownItem>
        </S.DropdownList>
      </S.StyledDropdown>
    </S.ShareContainer>
  );
};

export default Share;
